/**
 * PATH: packages/email-hub/src/feature/pages/TrashPage.tsx
 * FILE_ID: EMAILHUB-FEATURE-PAGES-TRASHPAGE-001
 * PURPOSE: The Binned folder. Renders the SAME page as the Inbox
 *          (`InboxPage`) with `folder="binned"`, exactly like ArchivedPage:
 *          identical command surface, list/reader split, auto-open first
 *          row and the full rich row toolkit. One frame, not a fork.
 * WHY:     Operator 2026-11-04: "the junk (binned) and email UIs don't look
 *          alike, they should have a similar UI". Binned was the last folder
 *          still on the thinner EmailFolderShell, so it drifted from the
 *          Inbox (no reader actions, no filter chrome). The inbox controller
 *          already knew `folder='binned'` (status=binned query, Restore on
 *          rows, Restore in the context menu); this page just stopped
 *          bypassing it.
 * LANDMINE: Binned rows are never hard-deleted. The backend `delete` action
 *          stamps status='binned' and keeps the row, so every verb here is
 *          reversible: Restore (row, bulk, all). Do not add an "Empty bin".
 * RELATED:
 *   - pages/InboxPage.tsx: the universal frame (accepts `folder`).
 *   - inbox-page/InboxCommandSurface.tsx: binned swaps Done/Junk for Restore
 *     and offers Restore all.
 *   - apps/<tenant>/src/features/email/pages/TrashPage.tsx: thin re-export.
 */

import InboxPage from './InboxPage'

export default function TrashPage() {
  return <InboxPage folder="binned" />
}
